export interface Theme {
  name: string;
  className: string;
  isCustom?: boolean;
  facilityId?: string;
}

export interface ColorsCodes {
  primaryColor: string;
  secondaryColor: string;
}

export interface FullColorsCodes {
  primaryDark: string;
  primaryColor: string;
  secondaryColor: string;
  primaryText: string;
  secondaryText: string;
  column1: string;
  column2: string;
  column3: string;
  column4: string;
}

export const themes: Theme[] = [
  {
    name: "Orange Theme",
    className: "theme-orange"
  },
  {
    name: "Pink Theme",
    className: "theme-pink"
  },
  {
    name: "Purple Theme",
    className: "theme-purple"
  },
  {
    name: "Light Green Theme",
    className: "theme-light-green"
  },
  {
    name: "Dark Green Theme",
    className: "theme-dark-green"
  },
  {
    name: "Dark Blue Theme",
    className: "theme-dark-blue"
  },
  {
    name: "Light Blue Theme",
    className: "theme-light-blue"
  },
  {
    name: "Grey Theme",
    className: "theme-grey"
  },
  {
    name: "Feddersen Theme",
    className: "theme-feddersen"
  }
  // Define custom themes for specific facilityId and inside getThemeAllColorsCodes add full color pallete
  // {
  //   name: "Custom Theme 1",
  //   className: "custom-theme-1",
  //   isCustom: true,
  //   facilityId: "8GGC8Cum7As49GI44uHv"
  // }
];

export const defaultTheme = {
  primaryDark: "#073946",
  primaryColor: "#F2D028",
  secondaryColor: "#64B4B4",
  primaryText: "#000F28",
  secondaryText: "#F5F7FC",
  column1: "#9FC7C7",
  column2: "#C8DADD",
  column3: "#D0D8DE",
  column4: "#D7D9DD"
};

export const getThemeAllColorsCodes = (themeClass: string): FullColorsCodes => {
  const themeColorsMap: Record<string, FullColorsCodes> = {
    "theme-orange": {
      primaryDark: "#CE8701",
      primaryColor: "#f2d028",
      secondaryColor: "#ee8100",
      primaryText: "#000F28",
      secondaryText: "#000F28",
      column1: "#F0B00C",
      column2: "#F0B00C99",
      column3: "#F0B00C66",
      column4: "#F0B00C26"
    },
    "theme-pink": {
      primaryDark: "#570B3F",
      primaryColor: "#f2d028",
      secondaryColor: "#d3065f",
      primaryText: "#000F28",
      secondaryText: "#F5F7FC",
      column1: "#C593C5",
      column2: "#C593C599",
      column3: "#C593C566",
      column4: "#C593C526"
    },
    "theme-purple": {
      primaryDark: "#2E0736",
      primaryColor: "#f2d028",
      secondaryColor: "#683772",
      primaryText: "#000F28",
      secondaryText: "#F5F7FC",
      column1: "#A593C5",
      column2: "#A593C599",
      column3: "#A593C566",
      column4: "#A593C526"
    },
    "theme-light-green": defaultTheme,
    "theme-dark-green": {
      primaryDark: "#073946",
      primaryColor: "#63B4B4",
      secondaryColor: "#137178",
      primaryText: "#000F28",
      secondaryText: "#F5F7FC",
      column1: "#a7c6c5",
      column2: "#a7c6c599",
      column3: "#a7c6c566",
      column4: "#a7c6c526"
    },
    "theme-dark-blue": {
      primaryDark: "#0B2E52",
      primaryColor: "#ec952b",
      secondaryColor: "#114578",
      primaryText: "#000F28",
      secondaryText: "#F5F7FC",
      column1: "#4C8AC6",
      column2: "#4C8AC699",
      column3: "#4C8AC666",
      column4: "#4C8AC626"
    },
    "theme-light-blue": {
      primaryDark: "#0B2E52",
      primaryColor: "#CCD3DF",
      secondaryColor: "#3575a0",
      primaryText: "#000F28",
      secondaryText: "#F5F7FC",
      column1: "#4C8AC6",
      column2: "#4C8AC699",
      column3: "#4C8AC666",
      column4: "#4C8AC626"
    },
    "theme-grey": {
      primaryDark: "#3B4146",
      primaryColor: "#bcc0c6",
      secondaryColor: "#7a818e",
      primaryText: "#000F28",
      secondaryText: "#F5F7FC",
      column1: "#BCC0C6",
      column2: "#BCC0C699",
      column3: "#BCC0C666",
      column4: "#BCC0C626"
    },
    "theme-feddersen": {
      primaryDark: "#CE8701",
      primaryColor: "#1886A3",
      secondaryColor: "#F0B00C",
      primaryText: "#F5F7FC",
      secondaryText: "#000F28",
      column1: "#F0B00C",
      column2: "#F0B00C99",
      column3: "#F0B00C66",
      column4: "#F0B00C26"
    }
    /* CUSTOM THEMES */
    // "custom-theme-1": {
    //   primaryDark: "#42f54e",
    //   primaryColor: "#42e3f5",
    //   secondaryColor: "#8d42f5",
    //   primaryText: "#f542ef",
    //   secondaryText: "#f54248",
    //   column1: "#e6d581",
    //   column2: "#ebe1af",
    //   column3: "#f0edc9",
    //   column4: "#f5f3dc"
    // }
  };

  return themeColorsMap[themeClass];
};

export const getFilteredThemes = (facilityId: string | undefined) => {
  if (!facilityId) {
    return [];
  }
  return themes.filter((theme) => !theme.isCustom || theme.facilityId === facilityId);
};
